module.exports = __webpack_public_path__ + "static/img/15.39ee5ca1.png";